export enum DialogSizeEnum {
    SMALL = '34rem',
    MEDIUM = '47.5rem',
    LARGE = '65rem',
    LARGE_2 = '75rem',
}

export enum DialogClass {
    NO_BOTTOM_PADDING = 'no-bottom-padding'
}
